module.exports = __webpack_public_path__ + "img/marker-satgas.f30d72a6.svg";